import { sampleSize } from 'lodash';

import { EMPTY_STRING } from '@e-socna/empty';

export function createRandomString(length = 12): string {
  const chars =
    'abcdefghijklmnopqrstufwxyzABCDEFGHIJKLMNOPQRSTUFWXYZ1234567890';
  const pwd = sampleSize(chars, length || 12);
  return pwd.join(EMPTY_STRING);
}
